import {CommonsComponentUtils} from '../../utils/ib-commons-component-utils';
import {CommonsHttpServicesConstantsType} from '../../constants/ib-commons-http-service-constants';
import { CommonsUserUtilsService } from '../../utils/ib-commons-user-utils.service';
import {getSalesforceUrl, getSFClientId} from '../../utils/ib-salesforce-utils';
import {CommonsModalService} from '../../ib-modal/services/ib-modal-service';

@Component('ib-ui-login-reusable-iframe-component', 'ibUiLoginReusableIframeComponent', {
    bindings: {
        loading: '<',
        flow: '@'
    },
    controllerAs: 'ibUiLoginReusableIframeCtrl',
    templateUrl: ['$rootScope', ($rootScope: CommonsRootScope) => {
        return `${$rootScope.routes.templates}ib-ui-login-reusable-iframe-view.html`;
    }]
}, ['$document', '$timeout', '$rootScope', '$scope', '$window', 'CommonsComponentUtils', 'CommonsHttpServicesConstants', 'CommonsUserUtilsService', 'localStorageService', 'CommonsModalService'], [])
class ibUiLoginReusableIframeController implements ng.IController {
    public isLoading: boolean;
    public afterLogin: typeof Function;
    public onError: typeof Function;
    public loading: typeof Function;
    public iframeType: string;
    public flow: string;
    private counter: boolean;
    private iframeElement: HTMLIFrameElement;

    constructor (
        private $document: ng.IDocumentService,
        private $timeout: ng.ITimeoutService,
        private $rootScope: CommonsRootScope,
        private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private CommonsComponentUtils: CommonsComponentUtils,
        private CommonsHttpServicesConstants: CommonsHttpServicesConstantsType,
        private CommonsUserUtilsService: CommonsUserUtilsService,
        private localStorageService: ng.local.storage.ILocalStorageService,
        private CommonsModalService: CommonsModalService
    ) {

        this.iframeType;
        this.flow;
        this.$window.addEventListener('message', this.iframeSendLocalInfo);
        this.$window.addEventListener('IDENTITY_LOGIN_FAILURE', this.loadIframe);
        this.$scope.$on('$destroy', () => {
            this.$window.removeEventListener('message', this.iframeSendLocalInfo);
            this.$window.removeEventListener('IDENTITY_LOGIN_FAILURE', this.loadIframe);
        });
    }

    $onInit = (): void => {
        this.loadIframe();
    };

    private iframeSendLocalInfo = (event) => {
        if (
            (event.origin === this.CommonsHttpServicesConstants.SALESFORCE_ENVIRONMENTS.PREE.replace('/IbIdentity', '') ||
            event.origin === this.CommonsHttpServicesConstants.SALESFORCE_ENVIRONMENTS.PREB.replace('/IbIdentity', '') ||
            event.origin === this.CommonsHttpServicesConstants.SALESFORCE_ENVIRONMENTS.INT_AWS.replace('/IbIdentity', '') ||
            event.origin === this.CommonsHttpServicesConstants.SALESFORCE_ENVIRONMENTS.PRE_AWS.replace('/IbIdentity', '') ||
            event.origin === this.CommonsHttpServicesConstants.SALESFORCE_ENVIRONMENTS.PRO_AWS ||
            event.origin === this.CommonsHttpServicesConstants.SALESFORCE_ENVIRONMENTS.PRO) &&
            typeof event.data === 'string'
        ) {
            if (event.data.split('_')[0] === 'ibLoginReusableIframeHeight') {
                const iframeReusableLogin = this.$document[0].getElementById('iframeReusableLoginId') as HTMLIFrameElement;
                iframeReusableLogin.style.height = event.data.split('_')[1];
                this.CommonsComponentUtils.equalHeight(this.$document[0].getElementById('check_in_boxes'), false);
            } else if (event.data === ('ibLoginIframe' + this.iframeType)) {
                this.loading();
            } else if (event.data.split('_')[0] === 'ibLoginPassangerHeight') {
                this.$window.dispatchEvent(new Event('resize'));
            }
            if(event.data==='loginOnRRSS'){
                localStorage.setItem('returnURL', window.location.origin + window.location.pathname + window.location.search + '#!/loading');
            }
        }


    };

    private loginIframeLoaded = () => {
        this.isLoading = false;
        this.CommonsComponentUtils.equalHeight(this.$document[0].getElementById('check_in_boxes'), false);
    };

    private loadIframe = () => {

        if(this.iframeElement) { 
            this.iframeElement.remove(); 
            if(this.flow === 'BKI_RG'){
                let modalBody: string = 'REST_SERVICE_ERROR_GENERAL';
                const modalObject: CommonsErrorsModel.CommonsErrorsDataGeneral = {
                    message: modalBody,
                    needsTranslate: true
                };
                this.CommonsModalService.showGenericError(modalObject, true, null);
            }
        }

        this.iframeElement = this.$document[0].createElement('iframe');
        const iframeUri = getSalesforceUrl() + this.CommonsHttpServicesConstants.SALESFORCE_TOKEN.iframeURI;
        const iframeClientId = getSFClientId();

        this.isLoading = true;
        switch (this.flow) {
                case 'BKI':
                    this.iframeType = '3';
                    break;
                case 'MMB_CKI':
                    this.iframeType = '4';
                    break;
                case 'BKI_RG':
                    this.iframeType = '5';
                    break;
        }
        this.iframeElement.src = iframeUri + 'expid_' + this.iframeType + this.$rootScope.appMarket + this.$rootScope.appLang;
        if (this.CommonsUserUtilsService.isSoftUser()) {
            this.iframeElement.src += '1';
        }
        this.iframeElement.src += '?response_type=code&prompt=login&client_id=' + iframeClientId + '&redirect_uri=' + this.$window.location.origin + '/integration/ibplus/login/';
        this.iframeElement.onload = this.loginIframeLoaded;
        this.iframeElement.width = '100%';
        this.iframeElement.id = 'iframeReusableLoginId';
        this.$timeout(() => {
            this.$document[0].getElementById('iframeReusableLogin').appendChild(this.iframeElement);
        });
    };

}